"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importStar(require("react"));

var Button_1 = __importStar(require("../Button"));

var index_1 = __importDefault(require("../SortSelectModal/index"));

var EditColumnsModal =
/** @class */
function (_super) {
  __extends(EditColumnsModal, _super);

  function EditColumnsModal(props) {
    var _this = _super.call(this, props) || this;

    _this.toggleModal = function () {
      _this.setState({
        modalOpen: !_this.state.modalOpen
      });
    };

    _this.closeModal = function () {
      _this.setState({
        modalOpen: false
      });
    };

    _this.submit = function (columns) {
      if (_this.props.onChange) {
        _this.props.onChange(columns);
      }

      _this.closeModal();
    };

    _this.state = {
      modalOpen: false
    };
    return _this;
  }

  EditColumnsModal.prototype.render = function () {
    var _a = this.props,
        editMessage = _a.editMessage,
        confirmMessage = _a.confirmMessage,
        className = _a.className;
    var cn = classnames_1.default('emankit__filter_bar__item', className);
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
      className: cn,
      key: "edit_filters"
    }, react_1.default.createElement(Button_1.default, {
      variant: Button_1.ButtonVariant.SecondaryWhite,
      onClick: this.toggleModal
    }, editMessage)), react_1.default.createElement(index_1.default, {
      open: this.state.modalOpen,
      onClose: this.closeModal,
      visible: this.props.visible,
      onSubmit: this.submit,
      items: this.props.columns,
      editMessage: editMessage,
      confirmMessage: confirmMessage
    }));
  };

  EditColumnsModal.defaultProps = {
    columns: [],
    visible: []
  };
  return EditColumnsModal;
}(react_1.Component);

exports.default = EditColumnsModal;